import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon, StarIcon } from 'lucide-react';
interface Testimonial {
  quote: string;
  name: string;
  age: number;
}
const testimonials: Testimonial[] = [{
  quote: 'Pensé que era un problema físico y terminé entendiendo que era ansiedad. Me cambió muchísimo la cabeza.',
  name: 'Martín',
  age: 29
}, {
  quote: 'Lo que más me ayudó fue el reset de estímulo y los audios. Me siento mucho más tranquilo.',
  name: 'Lucas',
  age: 32
}, {
  quote: 'Había probado de todo y esto fue lo único que realmente me ayudó a entender el problema.',
  name: 'Nicolás',
  age: 27
}, {
  quote: 'Antes evitaba situaciones por miedo a fallar. Hoy me siento mucho más seguro.',
  name: 'Franco',
  age: 26
}];
export function TestimonialsSection() {
  return <section className="relative w-full bg-black py-10 md:py-14 overflow-hidden" data-id="element-434">
      <div className="absolute inset-0 z-0" data-id="element-435">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full bg-red-800/15 blur-[150px]" data-id="element-436" />
        <div className="absolute inset-0" style={{
        background: 'radial-gradient(ellipse at center, transparent 0%, rgba(0,0,0,0.6) 70%, #000 100%)'
      }} data-id="element-437" />
      </div>

      <div className="absolute top-0 left-0 right-0 h-16 bg-gradient-to-b from-[#0a0a0a] to-transparent z-10" data-id="element-438" />
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-[#0a0a0a] to-transparent z-10" data-id="element-439" />

      <div className="relative z-20 max-w-6xl mx-auto px-6" data-id="element-440">
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} data-id="element-441">
          <div className="text-center mb-10" data-id="element-442">
            <div className="flex items-center justify-center gap-3 mb-4" data-id="element-443">
              <div className="w-10 h-px bg-red-600" data-id="element-444" />
              <span className="text-red-500 text-xs uppercase tracking-[0.3em] font-bold" data-id="element-445">
                Hombres reales · Cambios reales
              </span>
              <div className="w-10 h-px bg-red-600" data-id="element-446" />
            </div>
            <h2 className="font-display text-3xl md:text-5xl uppercase text-white drop-shadow-[0_0_20px_rgba(220,38,38,0.3)]" data-id="element-447">
              Lo que dicen quienes ya lo hicieron
            </h2>
          </div>

          {/* Compact 2x2 grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-4xl mx-auto" data-id="element-448">
            {testimonials.map((t, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 15
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.08,
            duration: 0.5
          }} className="relative bg-gradient-to-b from-[#0a0a0a] to-black border border-red-900/40 rounded-xl p-5 md:p-6 shadow-[0_0_20px_rgba(220,38,38,0.05)] hover:border-red-600/50 hover:shadow-[0_0_30px_rgba(220,38,38,0.15)] transition-all duration-500" data-id="element-449">
                <div className="flex items-center justify-between mb-3" data-id="element-450">
                  <QuoteIcon className="w-5 h-5 text-red-500/70" fill="currentColor" data-id="element-451" />
                  <div className="flex items-center gap-0.5" data-id="element-452">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-3 h-3 text-yellow-500 fill-yellow-500" data-id="element-453" />)}
                  </div>
                </div>

                <p className="text-sm md:text-base text-gray-200 leading-relaxed mb-4 italic" data-id="element-454">
                  "{t.quote}"
                </p>

                <div className="flex items-center gap-3 pt-3 border-t border-red-900/30" data-id="element-455">
                  <div className="w-9 h-9 rounded-full bg-gradient-to-br from-red-700 to-red-900 border border-red-500/40 flex items-center justify-center text-white font-bold text-sm shadow-[0_0_10px_rgba(220,38,38,0.3)]" data-id="element-456">
                    {t.name.charAt(0)}
                  </div>
                  <div data-id="element-457">
                    <p className="text-white font-semibold text-sm" data-id="element-458">
                      {t.name}, {t.age} años
                    </p>
                    <p className="text-gray-500 text-xs uppercase tracking-wider" data-id="element-459">
                      Cliente verificado
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>

          <p className="text-center mt-8 text-xs md:text-sm text-gray-500 uppercase tracking-widest flex items-center justify-center gap-3" data-id="element-460">
            <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-461" />
            Cientos de hombres ya empezaron su transformación
          </p>
        </motion.div>
      </div>
    </section>;
}